import type { App } from 'vue'
import { CHAVE_OPERACOES_CATALOGO_USUARIO } from '@next/modulos/governanca/usuario/catalogo/apresentacao/catalogo-usuario.injecao'
import type { OperacoesCatalogoUsuario } from '@next/modulos/governanca/usuario/catalogo/catalogo-usuario.tipos'
import { criarCasoDeUsoListarOpcoesUsuario } from '@next/modulos/governanca/usuario/catalogo/listar-opcoes/listar-opcoes-usuario'
import { ListarOpcoesUsuarioRepositorioHttp } from '@next/modulos/governanca/usuario/catalogo/listar-opcoes/listar-opcoes-usuario.repositorio-http'
import type { InfraestruturaAplicacao } from '../criar-infraestrutura'
export const comporCatalogoUsuario = (
  infraestrutura: InfraestruturaAplicacao,
): OperacoesCatalogoUsuario => {
  const repositorio = new ListarOpcoesUsuarioRepositorioHttp(infraestrutura.httpCondominio)
  return { listarOpcoes: criarCasoDeUsoListarOpcoesUsuario(repositorio.executar) }
}
export const instalarUsuario = (app: App, infraestrutura: InfraestruturaAplicacao): void => {
  app.provide(CHAVE_OPERACOES_CATALOGO_USUARIO, comporCatalogoUsuario(infraestrutura))
}
